import { z } from 'zod'

/** Decimal string tutar (en fazla 2 ondalık). */
export const amountRule = (msg: string) => z.string().regex(/^\d+(\.\d{1,2})?$/, msg)
